import React from "react";
import FieldConfig from "../../proto/field-config";
import FieldProto from "../../proto/field-proto";
import FieldTask_View from "./render/view";
import Task from "../../../model2/task/task";
import FieldTask_ViewSmall from "./render/view-small";
import FieldTask_ViewReference from "./render/view-reference";
import FieldTask_GListView from "./render/glist-view";

export default class FieldTask extends FieldProto {

    FIELD_DEFAULT_WIDTH = 200;

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Task";
        // this.typeGroup          = GROUP_INFO
        // this.typeDescription    = "Email input field"
        this.icon               = 'i5-task';

        // this.components = {
        //     ValueIcon: <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
        // }

        this.renderComponents.view          = FieldTask_View
        this.renderComponents.viewSmall     = FieldTask_ViewSmall
        this.renderComponents.viewReference = FieldTask_ViewReference
        this.renderComponents.viewProperty  = FieldTask_ViewSmall
        this.renderComponents.glistView     = FieldTask_GListView
    }


    // normalize value for sorting
    sortValue(value:Task, model?:any) {
        return value ? value.title.toLowerCase() : ''
    }
}
